module.exports = __webpack_public_path__ + "static/media/party.5e7791cd.svg";